import { HTMLAttributes } from 'react'
import Link from 'next/link'

import Container from '@/components/base/Container'
import Image from '@/components/base/Image'
import Motion from '@/components/base/Motion'
import Typography from '@/components/base/Typography'
import TypographyMask from '@/components/base/TypographyMask'
import { useStore } from '@/contexts/store'

import { opacityReveal } from './animations/opacity'
import { cn } from '@/lib/utils'
import { WPImage } from '@/types'

export type CasiBlockProps = HTMLAttributes<HTMLElement> &
  Partial<{
    collection: {
      id: number
      title: string
      date: string
      link: string
      description: string
      image: WPImage
    }[]
  }>

const CasiBlock = ({ collection, ...props }: CasiBlockProps) => {
  const { strings } = useStore()
  return (
    <section {...props} className={cn([])}>
      <Container className="space-y-[60px]">
        {collection?.map((item) => (
          <Motion animation={opacityReveal} key={item.id}>
            <div className="flex flex-col justify-between md:flex-row">
              <div className="flex flex-1 flex-col gap-[15px] pr-[30px]">
                <Typography variant="label">{item.date}</Typography>
                <Link
                  href={item?.link || ''}
                  className={cn('underline-effect self-start')}
                  data-only-text-link
                  scroll={false}
                >
                  <Typography variant="h5">{`<b>${item.title}</b>`}</Typography>
                </Link>
                <Typography variant="body">{item.description}</Typography>
                <Link
                  href={item?.link || ''}
                  className={cn('underline-effect self-start')}
                  data-only-text-link
                  scroll={false}
                >
                  <TypographyMask>
                    <span>{strings?.label?.read_more}</span>
                  </TypographyMask>
                </Link>
              </div>
              {item.image && (
                <div className="flex-0 relative -order-1 mb-[30px] aspect-video w-[240px] md:order-1">
                  <Link
                    href={item?.link || ''}
                    data-only-text-link
                    scroll={false}
                  >
                    <Image
                      source={item.image}
                      alt={item.title}
                      size="full"
                      fit="cover"
                    />
                  </Link>
                </div>
              )}
            </div>
          </Motion>
        ))}
      </Container>
    </section>
  )
}

export default CasiBlock
